import styled from 'styled-components';

const ToggleButton = styled.div<{ $isVisible: boolean }>`
    display: flex;

    flex-direction: row;

    justify-content: center;
    align-content: center;
    align-items: center;

    font-size: 12px;

    user-select: none;

    & svg {
        margin-left: 5px;
        margin-top: 1px;

        transform: rotate(${props => (props.$isVisible ? '180deg' : '0')});
        transition: transform 0.2s ease;
    }
`;

export default ToggleButton;
